import './browser.js';
export const supportedLocales = ['zh-CN', 'en-US'];
const runtime = globalThis.PromptAssistantI18n;
export const defaultLocale = runtime.DEFAULT_LOCALE;
export const resolveLocale = runtime.resolveLocale;
export const createI18n = runtime.createI18n;
